import { Component, Input } from '@angular/core';
import { BsModalRef, BsModalService,ModalOptions } from 'ngx-bootstrap/modal';
import { BrandModalComponent } from '../../../shared/components/brand-modal/brand-modal.component';
import { Subscription } from 'rxjs';
import {SharedService} from '../../../shared/services/shared.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
@Component({
    selector: 'app-brands',
    templateUrl: './brands.component.html',
    styleUrls: ['./brands.component.scss'],
    standalone: false
})
export class BrandsComponent  {

  @Input() topBrandsListing:Array<any>=[];
  @Input() brandsListing:Array<any>=[];
  @Input() headerBrandsAlphabet:Array<any>=[];
  modalRef?: BsModalRef;
  modalSubscriber$!:Subscription;

  constructor(
    private modalService: BsModalService,
    private sharedService:SharedService,
    public statePersist: StatePersistService
    ) { }

  slideConfigbrands = {
    "slidesToShow": 9,
    "slidesToScroll": 1,
    "infinite": true,
    "loop": true,
    "autoplay": {
      delay : 2000,
    },
    "draggable": true,
    'responsive': [
      { 'breakpoint': 1700, 'settings': {'slidesToShow': 9,"slidesToScroll": 1}},
      { 'breakpoint': 992, 'settings': {'slidesToShow': 5,"slidesToScroll": 1}},
      { 'breakpoint': 767, 'settings': {'slidesToShow': 3,"slidesToScroll": 1}},
      { 'breakpoint': 500, 'settings': {'slidesToShow': 2,"slidesToScroll": 1}},
    ]
  };


  openBrandModal():void{

    const initialState: ModalOptions = {
      initialState: {
        brandsList:this.brandsListing,
        headerBrandsAlphabet:this.headerBrandsAlphabet,
        originalBrandListing:JSON.parse(JSON.stringify(this.brandsListing))
      },
      backdrop:'static',
      class: 'modal-lg-brands' 
    };

    this.modalRef = this.modalService.show(BrandModalComponent,initialState); 

  }

  onBrandSelection(brandId:number):void{
    let productData = JSON.parse(JSON.stringify(this.statePersist.getLocalStorage('product_data')));
    productData = {...productData,brand_filter:brandId.toString()};

    this.statePersist.setLocalStorage('product_data', productData);
    this.sharedService.redirectAsBrandSelected(brandId,false,{});
  }


  ngOnDestroy(){
    this.modalSubscriber$?.unsubscribe();
  }

}
